import { Launch } from '@mui/icons-material';
import { Box, IconButton, Tooltip, Typography } from '@mui/material';
import React, { useCallback } from 'react';
import { useModuleDrawerContext } from '../../../../contexts/ModuleDrawerContext';
import { UserConfigurableModule } from '../../../../types/User';
import { drawerModulePaths } from './ModuleDrawer';
import AppLink from '../../AppLink/AppLink';

type DrawerLinkProps = {
  module: UserConfigurableModule;
  uuid: string;
  children: React.ReactNode;
};

const DrawerLink: React.FC<DrawerLinkProps> = ({ module, uuid, children }) => {
  const { setModuleDrawerState } = useModuleDrawerContext();

  const openDrawer = useCallback(
    (e: React.MouseEvent) => {
      e.stopPropagation();
      setModuleDrawerState({ module, uuid });
    },
    [module, uuid, setModuleDrawerState]
  );

  const url = `/${drawerModulePaths[module]}/${uuid}`;

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 0.75,
        minWidth: 0,
      }}
    >
      <Typography
        variant="body2"
        onClick={openDrawer}
        sx={{
          cursor: 'pointer',
          textDecoration: 'underline',
          textUnderlineOffset: '2px',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          maxWidth: '100%',
        }}
        title={typeof children === 'string' ? children : undefined}
      >
        {children}
      </Typography>

      <Tooltip title="Open full page">
        <IconButton component={AppLink} to={url} size="small">
          <Launch fontSize="inherit" />
        </IconButton>
      </Tooltip>
    </Box>
  );
};

export default DrawerLink;
